import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import getAuthToken from "helpers/getAuthToken";

export const prepareHeaders = async (headers: Headers) => {
  const token = await getAuthToken();
  headers.set("Authorization", `Bearer ${token}`);
  return headers;
};

export const appBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_REST_API_URL}`,
  prepareHeaders,
});

export const accountBaseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_AZURE_AD_GRAPH_API_URL}`,
  prepareHeaders,
});
